module.exports = require("core-js-pure/features/get-iterator-method");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js
// module id = 2037
// module chunks = 25